import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import styles from './ClassNameEditor.module.css';
import { useTranslation } from 'react-i18next';
const ClassNameEditor = ({ option, setOption, accountingData }) => {
  const [selectedClass, setSelectedClass] = useState(null);
  const [classOptions, setClassOptions] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    const uniqueNames = Array.from(new Set(accountingData.map((entry) => entry.className)));
    setClassOptions(uniqueNames);
    //setSchoolOptions(accountingData);
  }, [accountingData]);

  useEffect(() => {
    if (selectedClass) {
      const newValue = `className=${selectedClass}`;
      if (decodeURI(option.value) !== decodeURI(newValue)) {
        setOption({ ...option, value: encodeURI(newValue) });
      }
    }
  }, [selectedClass]);

  return (
    <div className={styles.mainContainer}>
      <Autocomplete
        disabled={!accountingData || accountingData?.length === 0}
        disablePortal
        disableClearable
        id='class-autocomplete'
        options={classOptions}
        getOptionLabel={(option) => option}
        sx={{ width: 300, fontFamily: 'var(--font-main)' }}
        value={selectedClass}
        className={styles.autocomplete}
        onChange={(event, selectedSchool) => {
          setSelectedClass(selectedSchool);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              style: { fontFamily: 'var(--font-main)' }
            }}
            label={t('chartQueryBuilder.queryParam.deliveryTargetClass')}
          />
        )}
      />
    </div>
  );
};

export default ClassNameEditor;
